import SwitchButton from 'components/Common/SwitchButton'
import FilterChip from 'components/Luxkit/Chips/FilterChip'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import React, { useCallback } from 'react'
import LuxPlusLogo from './Logos/LuxPlusLogo'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import { isSpoofed } from 'selectors/featuresSelectors'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'

interface Props {
  displayMemberPrice: boolean;
  offer: App.Offer;
  isSpoofed: boolean;
}

function OfferCalendarLuxPlusToggle({ displayMemberPrice, offer, isSpoofed }: Props) {
  const dispatch = useOfferPageDispatch()

  const onLuxPlusToggle = useCallback(() => {
    dispatch({ type: OfferPageActions.setDisplayMemberPrice, displayMemberPrice: !displayMemberPrice })
  }, [dispatch, displayMemberPrice])

  if (offer.luxPlus.access === 'memberOnly' && !isSpoofed) {
    return null
  }

  return <FilterChip
    size="medium"
    endIcon={
      <ProductPaletteProvider palette="lux-plus">
        <SwitchButton toggled={displayMemberPrice} nonInteractive />
      </ProductPaletteProvider>
    }
    data-testid="memberPrice-toggle"
    onClick={onLuxPlusToggle}
  >
    <LuxPlusLogo height={10} />
  </FilterChip>
}

export default withOfferPageAndReduxState((state, appState) => ({
  displayMemberPrice: state.displayMemberPrice,
  offer: state.offer,
  isSpoofed: isSpoofed(appState),
}))(OfferCalendarLuxPlusToggle)
